import { GzDialogWebComponent } from '../../../ui/gzDialog';

export class RemoveProductConfirmationWindow {
  public static showRemoveProductConfirmationWindow(
    translateFn,
    cancelCallback?: null | EventListenerOrEventListenerObject,
    confirmCallback?: null | EventListenerOrEventListenerObject
  ) {
    const dialogBodyHtml = `
      <p>${translateFn('By removing the product from Control Center:')}</p>
      <ul>
        <li>${translateFn('You will lose protection ensured by the product, if the license is still valid.')}</li>
        <li>${translateFn('Access to the related features will be restricted in product interface and in API.')}</li>
        <li>${translateFn(
          'If Security Server is no longer available, Antimalware scanning mode will adjust from Central Scanning to the set fallback option.'
        )}</li>
        <li>${translateFn(
          'If it is the only standard product, any associated add-on will also be removed and Network Inventory will no longer display your endpoints.'
        )}</li>
        <li>${translateFn(
          'If Full Disk Encryption is removed, endpoints remain encrypted and you will lose access to recovery keys. You will be able to disable BitLocker from Windows though.'
        )}</li>
        <li>${translateFn(
          'If this product is removed, all sensors and other associated licenses will be removed as well.'
        )}</li>
      </ul>
      <p>${translateFn('Any existing data in reports, notifications and user activity will remain.')}</p>
    `;

    const dialogFooterHtml = `
      <gz-button id='confirm' type='outline' color='negative' class='mr-2'>
       ${translateFn('Remove')}
      </gz-button>
      <gz-button id='cancel' type='outline' color='secondary'>
        ${translateFn('Cancel')}
      </gz-button>
    `;

    const dialogTitle = translateFn('Remove product?');

    GzDialogWebComponent.computeCustomDialog(
      dialogBodyHtml,
      dialogFooterHtml,
      dialogTitle,
      cancelCallback,
      confirmCallback
    );
  }
}
